import { createSlice } from "@reduxjs/toolkit";

export const priceSlice = createSlice({
  name: "price",
  initialState: {
    price: 0,
  },
  reducers: {
    setStorePrice: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setStorePrice } = priceSlice.actions;

export default priceSlice.reducer;
